import * as React from 'react';
import {
  IProductFeatureContext,
  ProductFeatureContext,
} from '@tock/shared/utils/productFeatureContext';
import { TockProductType } from '@tock/shared/types/productFeatures';

interface Props {
  productType?: TockProductType;
  children?: React.ReactChild | React.ReactChildren;
}

export default class ProductFeatureProvider extends React.PureComponent<Props> {
  render() {
    const value: IProductFeatureContext = { productType: this.props.productType } || {};
    return (
      <ProductFeatureContext.Provider value={value}>
        {this.props.children}
      </ProductFeatureContext.Provider>
    );
  }
}
